<template>
  <div class="main m-header">
    <div class="right">
      <img class="right-img" src="../../assets/mdashu/navlogo.png" alt />
      <i class="el-icon-more right-i" @click.stop="didClickMenus"></i>
      <b class="right-i right-i2" v-if="ischinese == 'cn'" @click.stop="didClickMenuss">CN</b>
      <b class="right-i right-i2" v-else @click.stop="didClickMenuss">EN</b>
      <ul class="ululul" :class="{active: isShow, none: !isShow}">
        <li class="item-top" @click="closeul">
          <i class="el-icon-close closei"></i>
        </li>
        <li
          v-for="(item, index) in menus"
          :key="index"
          @click="didSelectItem(index , item.path)"
          :class="item.class"
          :style="navName == item.path ? 'color:#000000' : ''"
        >{{item.name}}</li>
      </ul>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- <router-view v-on:banner="childBanner"/> -->
      <router-view />
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="footer-nav">
        <div class="fv">
          <router-link to="mEnter">{{home}}</router-link>
        </div>
        <div class="fv fvr">
          <router-link to="mSchool">{{news}}</router-link>
        </div>
        <div class="fv">
          <router-link to="mChildren">{{service}}</router-link>
        </div>
        <div class="fv fvr">
          <router-link to="mContact">{{about}}</router-link>
        </div>
        <div class="fv">
          <router-link to="mNotice">{{innovate}}</router-link>
        </div>
        <div class="fv fvr">
          <router-link to="mRecruit">{{join}}</router-link>
        </div>
      </div>
      <div class="fabout">
        <p class="fp1">{{ci}}</p>
        <p class="fp2">{{ci1}}：{{ischinese == "cn" ?this.address:this.address_en}}</p>
        <p class="fp3">{{ci2}}：{{this.email}}</p>
        <p class="fp4">{{ci3}}：{{this.tel}}</p>
        <p class="fp5">Copyright {{this.year}} 深圳前海融森科技有限公司版权所有 | 粤</p>
        <p class="fp6">ICP备18131974号</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject:['reload'],
  name: "m-header",
  mounted() {
    let screenWidth = window.screen.width;
    let baseWidth = 1920;
    this.iSize = (screenWidth / baseWidth) * 200 + "px";
  },
  data() {
    return {
      ischinese: "cn",

      home: "首页",
      service: "我们的服务",
      innovate: "创新",
      news: "新闻中心",
      about: "关于我们",
      join: "加入我们",
      ci: "联系方式",
      ci1: "地址",
      ci2: "电话",
      ci3: "邮箱",
      isShow: false,
      tel: "",
      address: "",
      address_en: "",
      email: "",
      year: "",
      navName: "mHeader",
      menus: [
        {
          name: "首页",
          class: "item-normal item-first",
          path: "mEnter"
        },
        {
          name: "我们的服务",
          class: "item-normal",
          path: "mChildren"
        },
        {
          name: "创新",
          class: "item-normal",
          path: "mNotice"
        },
        {
          name: "新闻中心",
          class: "item-normal",
          path: "mSchool"
        },
        {
          name: "关于我们",
          class: "item-normal",
          path: "mContact"
        },
        {
          name: "加入我们",
          class: "item-last",
          path: "mRecruit"
        }
      ],
      iSize: 50
    };
  },
  methods: {
    didClickMenus() {
      this.isShow = true;
    },
    didClickMenuss() {
      if (this.ischinese == "cn") {
        this.ischinese = "en";
        window.localStorage.setItem("ischinese", "en");
        // this.$router.go(0);
        this.reload();
      } else if (this.ischinese == "en") {
        this.ischinese = "cn";
        window.localStorage.setItem("ischinese", "cn");
        // this.$router.go(0);
        this.reload();
      }
    },
    didSelectItem(index, name) {
      this.isShow = false;
      this.$emit("select-menu", index);
      this.navName = name;
      this.$router.push({ name: name });
    },
    closeul() {
      if (this.isShow) {
        this.isShow = false;
      }
    },
    getList() {
      this.$http
        .post("/api/dashu/footer/footerList", {})
        .then(res => {
          // console.log(res)
          var code = res.data.code;
          if (code === 0) {
            this.tel = res.data.data.about.telphone;
            this.address = res.data.data.about.address;
            this.address_en = res.data.data.about.address_en;
            this.email = res.data.data.about.email;
            // console.log(this.tel,this.address,this.email)
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    }
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannertitle1 = "Dashu United Group";
      this.bannertitle2 =
        "Founded in 2018, Dashu united group is mainly engaged in ";
      this.bannertitle3 =
        "e-commerce, design, program and other Internet businesses";
      this.home = "HomePage";
      this.service = "OurServices";
      this.innovate = "Innovation";
      this.news = "InformationCenter";
      this.about = "AboutUs";
      this.join = "JoinUs";
      this.ci = "Contact information";
      this.ci1 = "Address";
      this.ci2 = "Tel";
      this.ci3 = "Email";
      this.menus = [
        {
          name: "HomePage",
          class: "item-normal item-first",
          path: "mEnter"
        },
        {
          name: "OurServices",
          class: "item-normal",
          path: "mChildren"
        },
        {
          name: "Innovation",
          class: "item-normal",
          path: "mNotice"
        },
        {
          name: "InformationCenter",
          class: "item-normal",
          path: "mSchool"
        },
        {
          name: "AboutUs",
          class: "item-normal",
          path: "mContact"
        },
        {
          name: "JoinUs",
          class: "item-last",
          path: "mRecruit"
        }
      ];
    }
    this.getList();
    var now = new Date();
    var year = now.getFullYear(); //获取当前年份
    this.year = year;
  }
};
</script>


<style scoped>
#m-header {
  background-color: white;
  display: flex;
  /* padding: 1.08rem 1.6rem; */
}
.right {
  flex: 1;
  height: 0.96rem;
  text-align: right;
  position: relative;
  background: white;
  z-index: 10000;
  border-top: 0.08rem solid #76c3a2;
}
.right-img {
  position: absolute;
  left: 0;
  top: 0;
  height: 0.62rem;
  width: 1.24rem;
  margin: 0.18rem 0 0.18rem 0.6rem;
}
.right-i {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.62rem;
  margin: 0.18rem 0.6rem 0.18rem 0;
  color: #76c3a2;
}
.right-i2 {
  position: absolute;
  right: 1rem;
  top: 0;
  font-size: 0.62rem;
  margin: 0rem 0.6rem 0rem 0;
  color: #76c3a2;
  height: 0.96rem;
  line-height: 0.96rem;
  font-size: 0.4rem;
}
.none {
  display: none;
}
.active {
  position: absolute;
  width: 5rem;
  /* background-color: rgb(161, 206, 243); */
  background-color: rgb(255, 255, 255);
  right: 0;
  top: 0;
  padding: 0 0.4rem 0.4rem;
}
.ululul {
  /* border: 1px solid red; */
  z-index: 100;
}
.item-top {
  font-size: 0.62rem;
  list-style-type: none;
  /* padding-right:0.5rem; */
  border-bottom: 1px solid #b2b2b2;
}
.closei {
  color: #76c3a2;
  font-size: 0.62rem;
  margin: 0.18rem 0.2rem;
}
.item-normal,
.item-last {
  font-weight: 400;
  color: #b2b2b2;
  font-size: 0.33rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  text-align: left;
  position: relative;
  list-style-type: none;
}
.item-first {
  padding-top: 0.86rem;
}
</style>
<style scoped>
/* 内容 */
.content {
  /* margin-top: 1rem; */
}
/* 底部 */
.footer {
  width: 100%;
  background: #2e3231;
  box-sizing: border-box;
  padding: 0.8rem 0.6rem;
  border-top: 0.3rem solid #76c3a2;
}
.footer-nav {
  border-bottom: 1px solid #b2b2b2;
  display: flex;
  flex-wrap: wrap;
}
.fv {
  width: 50%;
  padding-bottom: 1.08rem;
  font-size: 0.3rem;
  margin: 0;
}
.fvr {
  text-align: center;
}
.fv a {
  color: white;
}
.fabout {
}
.fabout p {
  color: white;
}
.fp1 {
  margin: 0.9rem 0 0.6rem 0;
  font-size: 0.3rem;
  font-weight: bold;
}
.fp2,
.fp3 {
  margin: 0 0 0.3rem 0;
  font-size: 0.3rem;
}
.fp4 {
  margin: 0 0 1rem 0;
  font-size: 0.3rem;
}
.fp5,
.fp6 {
  font-size: 0.2rem;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/mbPages/mHeader.vue